import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../StuStyles/StudentProfile.css";
import { useNavigate, useLocation } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";

import ApiService from "../../../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

const TpoapproveView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const membershipId = location.state?.membershipId;

  const [data, setData] = useState(null);
  const [member, setMember] = useState({});
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);

  /* =========================
     FETCH API DATA
  ========================== */
  useEffect(() => {
    if (membershipId) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [membershipId]);

  const fetchData = async () => {
    try {
      setLoading(true);

      console.log("MEMBERSHIP ID =>", membershipId);

      const res = await AdminAPI.getMemberById(membershipId);

      console.log("FULL API RESPONSE =>", res.data);

      const responseData = res?.data || {};

      /*
        EXPECTED API FORMAT:
        {
          member: { ... },
          details: { ... }
        }
      */

      const memberData =
        responseData?.member ||
        responseData?.data?.member ||
        {};

      const detailsData =
        responseData?.details ||
        responseData?.data?.details ||
        {};

      setMember(memberData);
      setDetails(detailsData);

      setData(responseData);

      console.log("MEMBER DATA =>", memberData);
      console.log("DETAILS DATA =>", detailsData);
    } catch (err) {
      console.error("API ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     IMAGE HANDLER
  ========================== */
  const getImage = (img) => {
    if (!img) {
      return "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
    }

    if (typeof img === "string") {
      return img.startsWith("http")
        ? img
        : `https://nhrc.onrender.com/${img}`;
    }

    return "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
  };

  /* =========================
     NO MEMBERSHIP ID
  ========================== */
  if (!membershipId) {
    return (
      <div className="container mt-5 text-center">
        <h4>No Membership ID Found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    );
  }

  /* =========================
     LOADING
  ========================== */
  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <h5>Loading...</h5>
      </div>
    );
  }

  /* =========================
     NO DATA
  ========================== */
  if (!data || !member) {
    return (
      <div className="container mt-5 text-center">
        <h4>No Representative Details Found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="container student-profile-container mt-5 mb-0">

      {/* ================= HEADER ================= */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mt-3">
          REPRESENTATIVE DETAILS
        </h4>
      </div>

      {/* ================= BACK BUTTON ================= */}
      <button
        className="jobback mb-3"
        onClick={() => navigate(-1)}
      >
        <TiArrowBack /> Back
      </button>

      {/* ================= PERSONAL DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Personal Details
        </h5>

        <div className="row g-3 mt-2">

          {/* PROFILE PHOTO */}
          <div className="col-md-4">
            <label className="empv-label">
              Profile Photo
            </label>

            <div>
              <img
                src={getImage(member.profile_pic)}
                alt="profile"
                className="img-fluid profile-pic"
                style={{
                  width: "150px",
                  height: "150px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                }}
              />
            </div>
          </div>

          {/* FULL NAME */}
          <div className="col-md-4">
            <label className="empv-label">
              Full Name
            </label>

            <input
              className="form-control"
              value={member.full_name || ""}
              readOnly
            />
          </div>

          {/* EMAIL */}
          <div className="col-md-4">
            <label className="empv-label">
              Email
            </label>

            <input
              className="form-control"
              value={member.email || ""}
              readOnly
            />
          </div>

          {/* MOBILE */}
          <div className="col-md-4">
            <label className="empv-label">
              Mobile
            </label>

            <input
              className="form-control"
              value={member.mobile || ""}
              readOnly
            />
          </div>

          {/* GENDER */}
          <div className="col-md-4">
            <label className="empv-label">
              Gender
            </label>

            <input
              className="form-control"
              value={member.gender || ""}
              readOnly
            />
          </div>

          {/* DOB */}
          <div className="col-md-4">
            <label className="empv-label">
              DOB
            </label>

            <input
              className="form-control"
              value={member.dob || ""}
              readOnly
            />
          </div>

          {/* BLOOD GROUP */}
          <div className="col-md-4">
            <label className="empv-label">
              Blood Group
            </label>

            <input
              className="form-control"
              value={member.blood_group || ""}
              readOnly
            />
          </div>

          {/* STATE */}
          <div className="col-md-4">
            <label className="empv-label">
              State
            </label>

            <input
              className="form-control"
              value={member.state || ""}
              readOnly
            />
          </div>

          {/* DISTRICT */}
          <div className="col-md-4">
            <label className="empv-label">
              District
            </label>

            <input
              className="form-control"
              value={member.district || ""}
              readOnly
            />
          </div>

          {/* PINCODE */}
          <div className="col-md-4">
            <label className="empv-label">
              Pincode
            </label>

            <input
              className="form-control"
              value={member.pincode || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* ================= REPRESENTATIVE DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Representative Details
        </h5>

        <div className="row g-3 mt-2">

          {/* MEMBERSHIP ID */}
          <div className="col-md-4">
            <label className="empv-label">
              Membership ID
            </label>

            <input
              className="form-control"
              value={member.membership_id || ""}
              readOnly
            />
          </div>

          {/* ROLE */}
          <div className="col-md-4">
            <label className="empv-label">
              Role
            </label>

            <input
              className="form-control"
              value={member.role || ""}
              readOnly
            />
          </div>

          {/* STATUS */}
          <div className="col-md-4">
            <label className="empv-label">
              Status
            </label>

            <input
              className="form-control"
              value={member.status || ""}
              readOnly
            />
          </div>

          {/* CANDIDATE TYPE */}
          <div className="col-md-4">
            <label className="empv-label">
              Candidate Type
            </label>

            <input
              className="form-control"
              value={member.candidate_type || ""}
              readOnly
            />
          </div>

          {/* WHATSAPP */}
          <div className="col-md-4">
            <label className="empv-label">
              WhatsApp Notification
            </label>

            <input
              className="form-control"
              value={String(member.whatsapp_notification)}
              readOnly
            />
          </div>

          {/* CREATED AT */}
          <div className="col-md-4">
            <label className="empv-label">
              Created At
            </label>

            <input
              className="form-control"
              value={member.created_at || ""}
              readOnly
            />
          </div>

          {/* APPROVED AT */}
          <div className="col-md-4">
            <label className="empv-label">
              Approved At
            </label>

            <input
              className="form-control"
              value={member.approved_at || ""}
              readOnly
            />
          </div>

          {/* REJECTED AT */}
          <div className="col-md-4">
            <label className="empv-label">
              Rejected At
            </label>

            <input
              className="form-control"
              value={member.rejected_at || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* ================= INSTITUTION DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Institution Details
        </h5>

        <div className="row g-3 mt-2">

          {/* COLLEGE NAME */}
          <div className="col-md-4">
            <label className="empv-label">
              College Name
            </label>

            <input
              className="form-control"
              value={details.college_name || ""}
              readOnly
            />
          </div>

          {/* DEPARTMENT */}
          <div className="col-md-4">
            <label className="empv-label">
              Department
            </label>

            <input
              className="form-control"
              value={details.department || ""}
              readOnly
            />
          </div>

          {/* DISTRICT */}
          <div className="col-md-4">
            <label className="empv-label">
              District
            </label>

            <input
              className="form-control"
              value={details.district || ""}
              readOnly
            />
          </div>

          {/* UNIVERSITY ADDRESS */}
          <div className="col-md-4">
            <label className="empv-label">
              University Address
            </label>

            <input
              className="form-control"
              value={details.university_address || ""}
              readOnly
            />
          </div>

          {/* OFFICIAL MAIL */}
          <div className="col-md-4">
            <label className="empv-label">
              Official Mail ID
            </label>

            <input
              className="form-control"
              value={details.official_mail_id || ""}
              readOnly
            />
          </div>

          {/* MOBILE NUMBER */}
          <div className="col-md-4">
            <label className="empv-label">
              Mobile Number
            </label>

            <input
              className="form-control"
              value={details.mobile_number || ""}
              readOnly
            />
          </div>

          {/* COLLEGE CODE */}
          <div className="col-md-4">
            <label className="empv-label">
              College Code
            </label>

            <input
              className="form-control"
              value={details.college_code || ""}
              readOnly
            />
          </div>

          {/* UNIVERSITY NAME */}
          <div className="col-md-4">
            <label className="empv-label">
              University Name
            </label>

            <input
              className="form-control"
              value={details.university_name || ""}
              readOnly
            />
          </div>

          {/* DESIGNATION */}
          <div className="col-md-4">
            <label className="empv-label">
              Designation
            </label>

            <input
              className="form-control"
              value={details.designation || ""}
              readOnly
            />
          </div>

          {/* STATE */}
          <div className="col-md-4">
            <label className="empv-label">
              State
            </label>

            <input
              className="form-control"
              value={details.state || ""}
              readOnly
            />
          </div>

          {/* PINCODE */}
          <div className="col-md-4">
            <label className="empv-label">
              Pincode
            </label>

            <input
              className="form-control"
              value={details.pincode || ""}
              readOnly
            />
          </div>

          {/* EXPERIENCE */}
          <div className="col-md-4">
            <label className="empv-label">
              Experience
            </label>

            <input
              className="form-control"
              value={details.experience || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* ================= DEBUG RESPONSE ================= */}
      <div className="card p-3">
        <h5 className="mb-3">
          Debug API Response
        </h5>

        <pre
          style={{
            fontSize: "12px",
            overflow: "auto",
          }}
        >
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>

    </div>
  );
};

export default TpoapproveView;